import React from "react";
import { Linkedin, Twitter, Mail } from "lucide-react";

const teamMembers = [
  {
    name: "MR. SATISH SHENDRE",
    role: "SENIOR CAD DRAFTSMAN",
    bio: "A highly experienced Senior CAD Draftsman specializing in creating precise structural and architectural drawings using AutoCAD.",
    img: "/team/user.png",
    socials: { linkedin: "#", twitter: "#", email: "mailto:piyush@example.com" },
  },
  {
    name: "MR. SHATRUGHNA SATPUTE",
    role: "CAD DRAFTSMAN",
    bio: "Detail oriented CAD Draftsman responsible for preparing accurate structural and architectural drawings based on engineer specifications.",
    img: "/team/user.png",
    socials: { linkedin: "#", twitter: "#", email: "mailto:saurabh@example.com" },
  },
  {
    name: "KHUSHAL UMREDKAR",
    role: "CAD DRAFTSMAN",
    bio: "Dedicated CAD Draftsman with hands-on experience in creating layout plans, sections, elevations, and detailed drawings.",
    img: "/team/user.png",
    socials: { linkedin: "#", twitter: "#", email: "mailto:abhishek@example.com" },
  },
  {
    name: "YOGESH SARVE",
    role: "CAD DRAFTSMAN",
    bio: "Competent CAD Draftsman proficient in converting sketches and design concepts into professional technical drawings.",
    img: "/team/user.png",
    socials: { linkedin: "#", twitter: "#", email: "mailto:jayshree@example.com" },
  },
  {
    name: "DIMPLE KHANDADE",
    role: "CAD DRAFTSMAN",
    bio: "Reliable CAD Draftsman with a  capable of producing clear and well structured drawings for residential, commercial, and industrial projects.",
    img: "/team/user.png",
    socials: { linkedin: "#", twitter: "#", email: "mailto:jayshree@example.com" },
  },
  {
    name: "AKASH RAUT",
    role: "STRUCTURAL ENGINEER",
    bio: "Experienced Structural Engineer specializing in analysis, design, and detailing of RCC and steel structures.",
    img: "/team/user.png",
    socials: { linkedin: "#", twitter: "#", email: "mailto:jayshree@example.com" },
  },
  {
    name: "PRASHANT WASNIK",
    role: "STRUCTURAL ENGINEER",
    bio: "Detail driven Structural Engineer skilled in structural modeling, load calculations, foundation design, and site inspections.",
    img: "/team/user.png",
    socials: { linkedin: "#", twitter: "#", email: "mailto:jayshree@example.com" },
  },
  {
    name: "YASH DORLIKAR",
    role: "STRUCTURAL ENGINEER",
    bio: "Professional Structural Engineer with expertise in designing residential, commercial, and industrial buildings.",
    img: "/team/user.png",
    socials: { linkedin: "#", twitter: "#", email: "mailto:jayshree@example.com" },
  },
   {
    name: "SUMEDHA JANGLEKAR",
    role: "ACCOUNTANT",
    bio: "Sumedha Janglekar managing financial records, preparing accounts, and ensuring accuracy in financial transactions.",
    img: "/team/user.png",
    socials: { linkedin: "#", twitter: "#", email: "mailto:jayshree@example.com" },
  },
  // Add more team members here
];

const TeamSection = () => {
  return (
    <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-16"  style={{
          backgroundImage: "url(/aaj-home/bg-section.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%"
        }}>
      <div className="text-center mb-12">
        <h2 className="text-4xl md:text-5xl font-bold text-[#011321] mb-4">Meet Our Team</h2>
        {/* <div className="w-20 h-[2px] bg-gray-300 mx-auto mb-4 mt-6"></div> */}
        <span className="block w-24 sm:w-32 md:w-40 h-0.5 sm:h-1 mx-auto lg:mx-auto bg-gradient-to-r from-yellow-500 via-yellow-300 to-white rounded-full mt-4 sm:mt-6 mb-4"></span>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
          Meet the experts behind our success
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">

        {teamMembers.map((member, idx) => (
          <div
            key={idx}
            className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-transform transform hover:-translate-y-2 p-6 flex flex-col items-center text-center border-t-4 border-[#00B9F1]"
          >
            <img
              src={member.img}
              alt={member.name}
              className="w-28 h-28 rounded-full object-cover mb-4   border"
            />
            <h3 className="text-lg font-semibold text-gray-900">{member.name}</h3>
            <p className="text-xs text-gray-500 mb-3">{member.role}</p>
            <p className="text-gray-600 text-sm">{member.bio}</p>
            {/* <div className="flex space-x-4 mt-4">
              {member.socials.linkedin && (
                <a href={member.socials.linkedin} target="_blank" rel="noopener noreferrer">
                  <Linkedin size={18} className="text-[#0A66C2]" />
                </a>
              )}
              {member.socials.twitter && (
                <a href={member.socials.twitter} target="_blank" rel="noopener noreferrer">
                  <Twitter size={18} className="text-[#1DA1F2]" />
                </a>
              )}
              {member.socials.email && (
                <a href={member.socials.email}>
                  <Mail size={18} className="text-[#f97316]" />
                </a>
              )}
            </div> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamSection;
